import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconChevronLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M15.5302 3.46967C15.8231 3.76256 15.8231 4.23744 15.5302 4.53033L8.23729 11.8232C8.13965 11.9209 8.13965 12.0792 8.23729 12.1768L15.5302 19.4697C15.8231 19.7626 15.8231 20.2374 15.5302 20.5303C15.2373 20.8232 14.7624 20.8232 14.4695 20.5303L7.17663 13.2375C6.49321 12.554 6.49321 11.446 7.17662 10.7626L14.4695 3.46967C14.7624 3.17678 15.2373 3.17678 15.5302 3.46967Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeft;
